import React from 'react';
import { Columns } from 'lucide-react';

interface ColumnSelectorProps {
  columns: number;
  onChange: (columns: number) => void;
}

export function ColumnSelector({ columns, onChange }: ColumnSelectorProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Columns size={20} className="text-gray-500" />
        <span className="text-base text-gray-600">Columns</span>
      </div>

      <input
        type="range"
        min="2"
        max="7"
        value={columns}
        onChange={e => onChange(parseInt(e.target.value))}
        className="w-32 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-500 [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-blue-500 [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:cursor-pointer"
      />

      <span className="text-base text-gray-600 w-4 text-center">{columns}</span>
    </div>
  );
}
